import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const TOOLTIP_SCHEMA = Object.freeze({
  LABEL: '',
  SUMMARIES: List<string>([]),
});
const RECORD = generateSchema(TOOLTIP_SCHEMA);
const KEYS: any = generateKeys(TOOLTIP_SCHEMA);

export class Tooltip extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get summaries(): List<string> {
    return this.get(KEYS.SUMMARIES);
  }
}
